import React from 'react'

import Header from './Layout/headerNotLogin'
import HeaderLogin from './Layout Login/header'
import Sidebar from './Layout Login/sidebar'
import Hubungan_Pasien from './CustRelation/index'
import Lokasi from './Location/index'
import Pendidikan from './EducationLevel/index'
import Level_Lokasi from './LocationLevel/index'
import Login from './Login/login'
import Kurir from './Kurir/index'
import Kategori_Faskes from './kategori_faskes/index'
import Darah from './Darah/index'
import DaftarPasien from './daftar_pasien/index'
import Detail_Dokter from './DetailDoctor/index'
import Dokter_Profile from './DoctorProfile/index'
import Menu from './Layout Login/menu'
import MenuNotLogin from './Layout/menuNotLogin'
import Profiles from './Profiles/root'
import Cari_Obat from './CariObat/modalSearch'
import RencanaKedatangan from './rencana_kedatangan/index'
import Bank from './Bank/root'
import TambahSpesialis from './Spesialis/index'
import Obat from './CariObat/listObat'
import FormCariDoctor from './Doctor/formCari'
import SearchDoctor from './Doctor/index'

import { config } from './Config/config'

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

class App extends React.Component {
    render() {
        return (
            <div >
                {/* <CustRelation /> */}
                <Router>
                    <Switch>
                        {!localStorage.getItem(config.token) ?
                            <>
                                <div class="main-wrapper">
                                    <div class="page-wrapperNotLog">
                                        <section class="contentNotLog">
                                            <div class="container-fluid">
                                                <div class="account-wrapper">
                                                    <Header />
                                                    <div class="account-page">
                                                        <div class="account-center">
                                                            <Route path="/detail_dokter">
                                                                <Detail_Dokter />
                                                            </Route>
                                                            <Route path="/dokter_profile">
                                                                <Dokter_Profile />
                                                            </Route>
                                                            <Route exact path="/obat" component={Obat} />
                                                            <Route exact path="/formCariDoctor" component={FormCariDoctor} />
                                                            <Route exact path="/cariDoctor" component={SearchDoctor} />
                                                            <Route exact path="/" component={MenuNotLogin} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <div class="main-wrapper">
                                    <HeaderLogin />
                                    <div>
                                        <Sidebar />
                                        <div class="page-wrapper">
                                            <div class="content">
                                                <div class="">

                                                    <Route path="/kurir">
                                                        <Kurir />
                                                    </Route>
                                                    <Route path="/pendidikan">
                                                        <Pendidikan />
                                                    </Route>
                                                    <Route path="/darah">
                                                        <Darah />
                                                    </Route>
                                                    <Route path="/kategori_faskes">
                                                        <Kategori_Faskes />
                                                    </Route>
                                                    <Route path="/relasi_pasien">
                                                        <Hubungan_Pasien />
                                                    </Route>
                                                    <Route path="/lokasi">
                                                        <Lokasi />
                                                    </Route>
                                                    <Route path="/level_lokasi">
                                                        <Level_Lokasi />
                                                    </Route>
                                                    <Route path="/detail_dokter">
                                                        <Detail_Dokter />
                                                    </Route>
                                                    <Route path="/pasien">
                                                        <DaftarPasien />
                                                    </Route>
                                                    <Route path="/rencana_kedatangan">
                                                        <RencanaKedatangan />
                                                    </Route>
                                                    <Route path="/profile">
                                                        <Profiles />
                                                    </Route>
                                                    <Route path="/bank">
                                                        <Bank />
                                                    </Route>
                                                    <Route path="/tambahSpesialis">
                                                        <TambahSpesialis />
                                                    </Route>
                                                    <Route exact path="/obat" component={Obat} />
                                                    <Route exact path="/formCariDoctor" component={FormCariDoctor} />
                                                    <Route exact path="/cariDoctor" component={SearchDoctor} />
                                                    <Route path exact="/" component={Menu} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </Switch>
                </Router>

            </div>
        )
    }
}
export default App